import React from 'react';
import { Grid } from '@mui/material';
import { CounterBox } from '@icoach/members/components';

const WorkoutMetrics = ({ weeklyWorkoutQuantity, totalWorkoutQuantity, monthlyWorkoutQuantity }) => {
    return (
        <Grid className={'workout-metrics'} container spacing={1}>
            <Grid item xs={4}>
                <CounterBox title="本週WO" className="counter-box-xl" counter={weeklyWorkoutQuantity} />
            </Grid>
            <Grid item xs={4}>
                <CounterBox title="總WO" className="counter-box-xl" counter={totalWorkoutQuantity} />
            </Grid>
            <Grid item xs={4}>
                <CounterBox title="月WO" className="counter-box-xl" counter={monthlyWorkoutQuantity} />
            </Grid>
        </Grid>
    );
};

export default WorkoutMetrics;
